/* eslint-disable max-len */
import React from 'react';
import { Dialog, Flex } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TRDialog({
  show,
  onClose,
  onOkay,
  title,
  message,
  okay,
  okayDisabled,
  okayVariant = 'primaryDestructive',
  children,
  type = 'question'
}) {
  const Component = type === 'question' ? Dialog.Question : Dialog.Message;
  return /*#__PURE__*/_jsx(Component
  // variant="theftRecoveryDialog"
  , {
    show: show,
    onOkay: onOkay,
    okayDisabled: okayDisabled,
    onClose: onClose
    // bodyVariant="theftRecoveryDialogBody"
    ,
    title: /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      children: [/*#__PURE__*/_jsx("img", {
        src: "https://recovr-ui-assets.storage.googleapis.com/icon-theft-recovery.png",
        alt: "Theft Recovery Icon",
        width: "24px",
        height: "24px"
      }), /*#__PURE__*/_jsx("b", {
        children: title
      })]
    }),
    message: message,
    okay: okay,
    okayVariant: okayVariant,
    cancelVariant: "primaryCancel",
    onCancel: onClose,
    children: children
  });
}